import { render } from "./HomeView.vue?vue&type=template&id=328a8b98"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=328a8b98&lang=scss"

import exportComponent from "F:\\work\\angren\\cabinet\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__